<form [formGroup]="roleForm" (ngSubmit)="saveRole(inProgress)">
  <div class=" modal-header">
    <h5 class="modal-title d-flex align-items-center">
      <i class="ri-user-location-line me-1 font-20 text-primary"></i>{{roleForm.value.id?'Update':'Add'}} Team Role
    </h5>
    <button type="button" class="btn-close text-end" data-bs-dismiss="modal" aria-label="Close" id="close"
      (click)="activeModal.close('Close')"></button>
  </div>
  <div class="modal-body">
    <div class="row g-3">
      <div class="col-md-8">
        <label for="name" class="form-label">Name <b class="text-secondary">*</b></label>
        <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
              class='bx bxs-purchase-tag'></i></span>
          <input type="text" class="form-control ps-1" id="name" placeholder="Enter role name"
            [ngClass]="{'is-invalid': submitted && r.name.errors}" formControlName="name" ngbAutofocus
            autocomplete="off" />
          <div class="invalid-feedback" *ngIf="submitted && r.name.errors">
            <span *ngIf="r.name.errors.required">Please provide a valid name.</span>
            <span *ngIf="r.name.errors.pattern">Team role name must be 1-250 chars</span>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <label for="type" class="form-label">Privilege<b class="text-secondary">*</b></label>
        <div class="input-group">
          <span class="input-group-text bg-transparent border-end-0"><i class='bx bxs-grid-alt'></i></span>
          <select class="form-select ps-1" formControlName="privilege"
            [ngClass]="{'is-invalid': submitted && r.privilege.errors}">
            <option selected disabled hidden ngValue="">Select a privilege</option>
            <option *ngFor=" let privilege of privileges;" [ngValue]="privilege.id">{{privilege.label}}</option>
          </select>
          <div class="invalid-feedback" *ngIf="submitted && r.privilege.errors">
            <span *ngIf="r.privilege.errors.required">Please select a privilege.</span>
          </div>
        </div>
      </div>
      <div class="col-md-10">
        <label for="description" class="form-label">Description</label>
        <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
              class='bx bx-clipboard'></i></span>
          <textarea type="text" class="form-control ps-1 " id="description" placeholder="Describe the role details."
            rows="1" [ngClass]="{'is-invalid': submitted && r.description.errors}" formControlName="description"
            autocomplete="off"></textarea>
          <div class="invalid-feedback" *ngIf="submitted && r.description.errors">
            <span *ngIf="r.description.errors.required">Please provide a valid description.</span>
            <span *ngIf="r.description.errors.pattern">Description must be 1-250 chars</span>
          </div>
        </div>
      </div>
      <div class="col-md-auto">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="disabled" formControlName="disabled">
          <label class="form-check-label" for="disabled">Disabled</label>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="activeModal.close('Close')" id="close-btn"><i
        class="bx bx-x"></i>Close</button>
    <button type="submit" class="btn btn-secondary" #inProgress [ngClass]="{'no-event':inProgress?.value=='true'}"
      id="save-btn">
      <ng-container *ngIf="inProgress?.value=='true'">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        {{roleForm.value.id?'Updating...':'Saving...'}}
      </ng-container>
      <ng-container *ngIf="inProgress?.value!='true'">
        <i class="bx bx-save"></i>{{roleForm.value.id?'Save Changes':'Save'}}
      </ng-container>
    </button>
  </div>
</form>